import styled from 'styled-components';
import { spaceMixin } from '@zillow/constellation';

export const StyledDateCalendarContainer = styled.div`
    .DateCalendar-input-container .Label {
        padding-bottom: ${spaceMixin('xs')};
    }
`;
